// extracted by mini-css-extract-plugin
module.exports = {"photoswipeGallery":"photoswipe-gallery-view_photoswipeGallery__3WKXp","list":"photoswipe-gallery-view_list__3fAA4","item":"photoswipe-gallery-view_item__1nsFO"};